import {  ampPurchaseAdditional, ampPurchaseStatus } from "../utils/AmplitudeEvents";

export const addSubscriptionUpsale = async (upsaleData,type)=>{
  let dataUrl = '/api/upsalePurchase.php';
  if(type==='paypal'){
    dataUrl = '/api/email-upsale-purchase-init.php'
  }else {
    ampPurchaseStatus('UpsaleStarted');
  }
  try {
    const response = await fetch(dataUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ upsaleData })
    });

    const data = await response.json();
    if (!response.ok) {
      if(type!=='paypal'){
        ampPurchaseStatus('UpsaleDecline');
      }
 
      return { data: null, error: data.error || 'Unknown server error' };
    }

    if(type!=='paypal'){
      ampPurchaseStatus('UpsaleComplete');
      ampPurchaseAdditional({
        currency: upsaleData.currency,
        payment_method: 'Stripe',
        price: upsaleData.totalPrice,
        productId: upsaleData.planID,
        quantity: 1
      })
      const emailSubmit = await fetch('/api/email-upsale-purchase-init.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ upsaleData })
      });
  
      const emailData = await emailSubmit.json();
      if (!emailSubmit.ok) {
        return { emailData: null, error: emailData.error || 'Unknown server error' };
      }
    }

    
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message || 'Fetch failed' };
  }
}